
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/folders/[folderId]",
      function () {
        return require("private-next-pages/folders/[folderId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/folders/[folderId]"])
      });
    }
  